import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Card from "../generic/Card";

function ChinWooInfo() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLearnMoreClick = () => {
    navigate("/chinwoo");
    window.scrollTo(0, 0);
  };

  const infoCards = [
    {
      id: "history",
      icon: "fas fa-history",
      title: t("chinwoo.history.title"),
      description: t("chinwoo.history.description"),
    },
    {
      id: "philosophy",
      icon: "fas fa-leaf",
      title: t("chinwoo.philosophy.title"),
      description: t("chinwoo.philosophy.description"),
    },
    {
      id: "techniques",
      icon: "fas fa-cogs",
      title: t("chinwoo.techniques.title"),
      description: t("chinwoo.techniques.description"),
    },
  ];

  return (
    <section
      className="relative z-10 bg-white pt-12 pb-12 transition-colors dark:bg-slate-800"
      id="chinwoo"
      aria-labelledby="chinwoo-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-10 text-center md:mb-12">
          <h2
            id="chinwoo-heading"
            className="relative mb-5 inline-block text-4xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-5xl"
          >
            {t("chinwoo.title")}
            <span
              className="absolute -bottom-2.5 left-1/2 h-0.5 w-16 -translate-x-1/2 rounded-full bg-primary dark:bg-primary-light"
              aria-hidden
            />
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-pretty text-lg leading-relaxed text-slate-600 dark:text-slate-400">
            {t("chinwoo.description")}
          </p>
        </header>

        <ul className="m-0 mb-10 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 lg:grid-cols-3">
          {infoCards.map((card) => (
            <li key={card.id} className="min-h-0">
              <Card
                icon={card.icon}
                title={card.title}
                description={card.description}
              />
            </li>
          ))}
        </ul>

        <div className="flex justify-center">
          <button
            type="button"
            onClick={handleLearnMoreClick}
            className="inline-flex items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-primary-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:bg-primary-light dark:hover:bg-primary dark:focus-visible:ring-primary-light/40 dark:focus-visible:ring-offset-slate-800 md:px-6 md:py-3"
          >
            <span>{t("button.see_more")}</span>
            <i className="fas fa-arrow-right text-xs opacity-90" aria-hidden />
          </button>
        </div>
      </div>
    </section>
  );
}

export default ChinWooInfo;
